export * from './IconFractureMultiple';
